<template>
  <div class="documente-wrapper">
  <DxDataGrid :ref="documenteDataGrid" :allowColumnReordering='true'
    :data-source='dsDocumente' :allowColumnResizing='true' :columnAutoWidth='false' :column-min-width='10'
    :columnResizingMode="'nextColumn'" :show-borders='true' :syncLookupFilterValues='false' :filter-sync-enabled='true'
    :show-column-lines="false" :show-row-lines="true" :row-alternation-enabled="true" :hover-state-enabled="true"
    height="100%" class="documente-grid"
    @row-dbl-click="onRowDblClick" @exporting="onExporting">
    <DxExport :enabled='true' :formats='["xlsx"]'
      :load-panel="{ enabled: true, showIndicator: true, text: 'Loading...' }" />
    <DxFilterRow :visible='true' />
    <DxGrouping :context-menu-enabled='true'>
      <DxTexts group-continued-message='Continuat de pe pagina anterioara'
        group-continues-message='Continuat pe pagina urmatoare' />
    </DxGrouping>
    <DxGroupPanel :visible='true' emptyPanelText='Trage aici o coloana pentru a grupa datele' />
    <DxLoadPanel :enabled='true' text="Loading..." :indicator-src="'reload6.gif'" />
    <DxSorting mode='multiple' />
    <DxStateStoring :enabled='true' type='custom' :custom-save="onGridStateSaving" :custom-load="onGridStateLoading" />
    <DxColumnChooser :enabled='true' mode='select' title='Selector coloane' :allowSearch="true" sortOrder="asc"></DxColumnChooser>
    <DxPaging :page-size='10' />
    <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20]" :show-info="true"
      :show-navigation-buttons="true" />
    <DxToolbar>
      <DxItem location="before" template="filterToggleTemplate" />
      <DxItem location="before" template="periodToggleTemplate" />
      <DxItem widget="dxButton" location="after" :options="addButtonOptions" />
      <DxItem name="exportButton" />
      <DxItem name="columnChooserButton" />
    </DxToolbar>

    <!-- ── Buton Deschide Document (fix la început, ca la Comenzi) ── -->
    <DxColumn caption="" width="50" :fixed="true" fixed-position="left" :allow-sorting="false" :allow-filtering="false"
      :allow-resizing="true" :allow-reordering="false" cell-template="deschideCellTemplate" />
    <!-- ── Buton Tipărire document (ca la Comenzi) ── -->
    <DxColumn caption="" width="50" :fixed="true" fixed-position="left" :allow-sorting="false" :allow-filtering="false"
      :allow-resizing="true" :allow-reordering="false" cell-template="tipareseCellTemplate" />

    <DxColumn data-field="Numar" />
    <DxColumn data-field="Categorie" />
    <DxColumn data-field="Tip" />
    <DxColumn data-field="Data" caption="Data Contabila" data-type="date" format="yyyy-MM-dd" />
    <DxColumn data-field="Document" caption="Document asociat" :visible="false" />
    <DxColumn data-field="Zona" caption="Zona" :visible="false" />
    <DxColumn data-field="AgentNume" caption="Nume Agent" :allowHiding="false" :showInColumnChooser="false"/>
    <DxColumn data-field="Curs" caption="Custom Curs Valutar" :visible="false" data-type="number" format="#,##0.0000" :allowSearch="false"/>
    <DxColumn data-field="LotFabricatie" caption="Lot Fabricatie" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="TvaLaIncasare" caption="TVA La Incasare?" :visible="false" cellTemplate="circleTemplate" :allowSearch="false"/>
    <DxColumn data-field="Explicatie" caption="Explicatie" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="DiverseExplicatii" caption="Diverse Explicatii" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="Observatii" caption="Observatii" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="ContractNumar" caption="Numar Contract" :visible="false" />
    <DxColumn data-field="LocDepozitare" caption="Loc de Depozitare" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="Autofacturat" caption="Autofacturat?" :visible="false" cellTemplate="circleTemplate" :allowSearch="false"/>
    <DxColumn data-field="Nota" caption="Nota Contabila" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="GrupPartener" caption="Grup Partener" :visible="false" />
    <DxColumn data-field="Partener" caption="Nume Partener" :visible="false" />
    <DxColumn data-field="PartenerStrada" caption="Strada Partener" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="PartenerStradaNumar" caption="Numar Strada Partener" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="PartenerScaraBloc" caption="Scara Bloc Partener" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="PartenerBloc" caption="Bloc Partener" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="PartenerLocalitate" caption="Localitate Partener" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="PartenerAtributFiscal" caption="Atribut Fiscal Partener" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="PartenerCod" caption="Cod Partener" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="PartenerCUI" caption="CUI Partener" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="DataDoc" caption="Data Document" :visible="false" data-type="date" format="yyyy-MM-dd" />
    <DxColumn data-field="Scadenta" caption="Data Scadenta" :visible="false" data-type="date" format="yyyy-MM-dd" />
    <DxColumn data-field="AreCAF" caption="Are CAF?" :visible="false" cell-template="circleTemplate" :allowSearch="false"/>
    <DxColumn data-field="ProcentCAF" caption="Procent CAF" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="ValoareCAF" caption="Valoare CAF" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="GestiuneIntrare" caption="Gestiune Intrare" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="GestiuneIesire" caption="Gestiune Iesire" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="GestionarIntrare" caption="Gestionar Intrare" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="GestionarIesire" caption="Gestionar Iesire" :visible="false" :allowSearch="false"/>
    <!-- <DxColumn data-field="Structura" caption="Structura" :visible="false" :allowFiltering="false" /> -->
    <DxColumn data-field="DataCreare" caption="Data Creare" :visible="false" data-type="date" format="yyyy-MM-dd" />
    <DxColumn data-field="DataModificare" caption="Data Modificare" :visible="false" data-type="date"
      format="yyyy-MM-dd" />
    <DxColumn data-field="UserCreare" caption="User Creare" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="UserModificare" caption="User Modificare" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="ValoareRON" caption="Valoare in RON" :visible="false" data-type="number" alignment="right"
      format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="ValoareTVARON" caption="Valoare TVA in RON" :visible="false" data-type="number"
      format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="TotalRON" caption="Total in RON" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="SoldRON" caption="Sold RON" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="Valoare" caption="Valoare" :visible="false" data-type="number" alignment="right"
      format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="Valuta" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="TVA" caption="TVA" :visible="false" data-type="number" alignment="right" format="#0'%'" :allowSearch="false"/>
    <DxColumn data-field="ValoareTVA" caption="Valoare TVA" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="Total" caption="Total" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="Adaos" caption="Adaos" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="AdaosValoare" caption="Valoare Adaos" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false"/>
    <DxColumn data-field="Sold" caption="Sold" :visible="false" data-type="number" format="#,##0.00" :allowSearch="false"/>
    <!-- <DxColumn cell-template="shareTemplate" :width="30" alignment="center" />

    <template #shareTemplate="{ data }">
      <DxButton icon="share" hint="Share" type="success" styling-mode="contained" @click="shareClicked(data.data)" />
    </template> -->

    <template #circleTemplate="{ data }">
      <div class="circle-container">
        <div v-if="data.value" class="circle circle-true">✔</div>
        <div v-else class="circle circle-false"></div>
      </div>
    </template>

    <template #deschideCellTemplate="{ data }">
      <DxButton icon="eyeopen" hint="Deschide Document" type="default" styling-mode="outlined"
        class="deschide-btn" @click="() => openDocument(data.data)" />
    </template>

    <template #tipareseCellTemplate="{ data }">
      <DxButton icon="print" hint="Tipărește document" type="default" styling-mode="outlined"
        class="deschide-btn" :disabled="isPrinting" @click="() => onTipareseDocument(data.data)" />
    </template>

    <template #filterToggleTemplate>
      <DxButton icon="filter" text="Filtre" styling-mode="contained" class="filter-toggle-btn"
        @click="$emit('toggle-filters')" />
    </template>

    <template #periodToggleTemplate>
      <DxButton icon="event" text="Perioadă" styling-mode="contained" class="filter-toggle-btn"
        @click="$emit('toggle-filters', 'date')" />
    </template>

  </DxDataGrid>
  </div>

  <DxPopup :visible="sharePopupVisible" width="430" height="170" :showTitle="true" :hideOnOutsideClick="switchSharePopup"
    :drag-enabled="true" position="center">
    <template #title>
      <div
        style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
        Copiază Link Detalii Document
      </div>
    </template>
    <div class="url-textbox">
      <DxTextBox :value="url" :readOnly="false">
        <DxTextBoxButton :options="copyButton" name="copy" :readOnly="false" />
      </DxTextBox>
    </div>
  </DxPopup>
  <DxPopup :visible="isPdfPreviewVisible" :width="1000" :height="800" :drag-enabled="true"
    :resize-enabled="true" :hide-on-outside-click="true" @update:visible="v => { if (!v) closePdfPreview(); }">
    <template #title>
      <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
        {{ pdfFileName || 'Previzualizare document' }}
      </div>
    </template>
    <div style="display:flex; flex-direction:column; height:100%;">
      <div style="flex:1; border-top:1px solid #ddd;">
        <iframe v-if="pdfBlobUrl" :src="pdfPreviewSrc" style="width:100%; height:100%; border:0;" />
      </div>
      <div style="display:flex; justify-content:center; align-items:center; gap:16px; padding:12px;">
        <DxButton text="Descarcă PDF" icon="download" type="success" @click="downloadPreviewReport" />
        <DxButton text="Închide" type="danger" icon="close" @click="closePdfPreview" />
      </div>
    </div>
  </DxPopup>
  <!-- Pas 1: alegerea tipului de document — restul câmpurilor apar abia după această alegere,
       filtrate pe flagurile Are* ale tipului (ca în legacy DOC_DocumentForm) -->
  <DxPopupAdd :visible="isTipPopupVisible" :show-title="true" height="320px" width="520px" :drag-enabled="true"
    :show-close-button="false">
    <template #title>
      <div class="popup-header">
        <i class="dx-icon-add popup-header-icon"></i>
        <span class="popup-header-title">Document nou</span>
      </div>
    </template>
    <div class="tip-popup-content">
      <DxDropDownBox ref="dropDownBoxRef" :data-source="dsTipDocumente" :value="newDocument.TipId" value-expr="Id"
        display-expr="Nume" placeholder="Selectează un tip de document..." :showClearButton="true"
        @value-changed="onDropDownValueChanged">
        <template #content="{ data }">
          <DxTreeView v-if="treeViewDataSource" :data-source="treeViewDataSource" :select-by-click="true"
            data-structure="tree" items-expr="items" key-expr="Id" :search-enabled="true" search-mode="contains"
            :select-nodes-recursive="false" :expand-nodes-on-search="true"
            @item-click="onTreeViewItemSelectionChanged" :focus-state-enabled="true" display-expr="Nume">
            <template #item="{ data: itemData }">
              <span :style="{ fontWeight: itemData.isCategory ? 'bold' : 'normal' }"> {{ itemData.Nume }} </span>
            </template>
          </DxTreeView>
        </template>
      </DxDropDownBox>
    </div>
    <div class="form-footer footer-modern">
      <div class="footer-right">
        <DxButton text="Continuă" type="success" width="120" height="32" styling-mode="outlined"
          @click="onTipContinue" />
        <DxButton text="Anulează" type="danger" width="120" height="32" styling-mode="outlined"
          @click="onCloseTipPopup" />
      </div>
    </div>
  </DxPopupAdd>

  <!-- Pas 2: câmpurile documentului — vizibile doar cele relevante pentru tipul ales la pasul 1
       (mapare 1:1 cu DOC_DocumentForm.cs: rowDocXxx.Visible = tip.AreXxx) -->
  <DxPopupAdd :visible="isModalAddVisible" :show-title="true" height="520px" width="640px" :drag-enabled="true" :show-close-button="false">
    <template #title>
      <div class="popup-header">
        <i class="dx-icon-add popup-header-icon"></i>
        <span class="popup-header-title">Adăugare document{{ tipNumeSelectat ? ' — ' + tipNumeSelectat : '' }}</span>
      </div>
    </template>
    <DxTabPanel :items="addTabItems" :selected-index="addSelectedTabIndex" @option-changed="onAddTabPanelOptionChanged"
      :swipe-enabled="false" class="filters-tabpanel modern-form">
      <template #title="{ data }">
        <div class="tab-title-wrapper">
          <i :class="data.icon"></i>
          <span class="tab-title-text">{{ data.title }}</span>
        </div>
      </template>
      <template #item="{ data }">
        <div class="accordion-item-content">
          <!-- General — câmpuri esențiale, mereu vizibile -->
          <div v-if="data.id === 'general'" class="filter-group-inner">
            <div class="filter-input">
              <DxTextBox label="Număr Document" label-mode="static" v-model:value="newDocument.Numar"
                :read-only="tipFlags?.EsteObligatie !== true"
                :hint="tipFlags?.EsteObligatie === true ? 'Introduceți numărul documentului (ex. numărul facturii primite de la furnizor)' : 'Numărul se generează automat la salvare'"
                :placeholder="tipFlags?.EsteObligatie === true ? 'Introduceți numărul...' : ''" />
            </div>
            <div class="filter-input" v-if="tipFlags?.ArePartener === true">
              <DxLookup label="Partener" label-mode="static" :data-source="dsPartener" :value="newDocument.PartenerId"
                value-expr="ID" display-expr="Nume" placeholder="Selectează un partener..." :showClearButton="true"
                :searchEnabled="true" @value-changed="onPartenerSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="filter-input" v-if="tipFlags?.AreAgentId === true">
              <DxLookup label="Agent" label-mode="static" :data-source="dsAgent" :value="newDocument.AgentId" value-expr="Id"
                display-expr="Nume" placeholder="Selectează un agent..." :showClearButton="true" :searchEnabled="true"
                @value-changed="onAgentSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="filter-input">
              <DxDateBox label="Data Contabilă" label-mode="static" v-model:value="newDocument.Data" type="date"
                display-format="dd-MM-yyyy" :show-clear-button="true" />
            </div>
            <div class="filter-input">
              <DxDateBox label="Data Document" label-mode="static" v-model:value="newDocument.DataDoc" type="date"
                display-format="dd-MM-yyyy" :show-clear-button="true" />
            </div>
            <div class="filter-input" v-if="tipFlags?.AreScadenta === true">
              <DxDateBox label="Data Scadență" label-mode="static" v-model:value="newDocument.DataScadenta" type="date"
                display-format="dd-MM-yyyy" :show-clear-button="true" />
            </div>
          </div>

          <!-- Financiar — mapare 1:1 cu DOC_DocumentForm.cs. Valoare/ValoareTVA/Total editabile
               doar dacă tipul de document NU are linii (altfel se calculează din DOC_Linii). -->
          <div v-if="data.id === 'financial'" class="filter-group-inner">
            <div class="tab-empty-state" v-if="!hasFinanciarTab">Acest tip de document nu are câmpuri financiare suplimentare.</div>
            <div class="filter-input" v-if="tipFlags?.AreIntrare === true">
              <DxLookup label="Gestiune Intrare" label-mode="static" :data-source="dsGestiune" :value="newDocument.GestiuneIntrareId"
                value-expr="Id" :display-expr="gestiuneDisplayExpr" placeholder="Gestiune intrare..." :showClearButton="true"
                :searchEnabled="true" @value-changed="onGestiuneIntrareSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="filter-input" v-if="tipFlags?.AreIesire === true">
              <DxLookup label="Gestiune Ieșire" label-mode="static" :data-source="dsGestiune" :value="newDocument.GestiuneIesireId"
                value-expr="Id" :display-expr="gestiuneDisplayExpr" placeholder="Gestiune ieșire..." :showClearButton="true"
                :searchEnabled="true" @value-changed="onGestiuneIesireSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="filter-input" v-if="tipFlags?.AreBanca === true">
              <DxLookup label="Cont Bancă/Casă" label-mode="static" :data-source="dsBanci" :value="newDocument.ContBancaCasaId"
                value-expr="Id" :display-expr="bancaDisplayExpr" placeholder="Selectează un cont..." :showClearButton="true"
                :searchEnabled="true" @value-changed="onBancaSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="form-field-grid">
              <DxLookup v-if="tipFlags?.AreValuta === true" label="Valută" label-mode="static" :data-source="dsValute"
                :value="newDocument.ValutaId" value-expr="Id" display-expr="Simbol" placeholder="Valută..."
                :showClearButton="true" :searchEnabled="true" @value-changed="onValutaSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
              <DxNumberBox v-if="tipFlags?.AreValuta === true" label="Curs" label-mode="static" :value="newDocument.Curs"
                :readOnly="true" @value-changed="onCursSelected" />
              <DxNumberBox v-if="tipFlags?.AreAdaos === true" label="Adaos (%)" label-mode="static"
                v-model:value="newDocument.Adaos" format="#0.00'%'" :min="0" :max="100" />
              <DxNumberBox v-if="tipFlags?.AreAdaos === true" label="Adaos (Val.)" label-mode="static" :value="0"
                format="#,##0.00" :read-only="true" hint="Se calculează din liniile documentului" />
              <DxNumberBox v-if="tipFlags?.AreValoare === true" label="Valoare" label-mode="static"
                v-model:value="newDocument.Valoare" format="#,##0.00" :read-only="tipFlags?.AreLinii === true" />
              <DxNumberBox v-if="tipFlags?.AreTva === true" label="TVA %" label-mode="static" v-model:value="newDocument.Tva"
                format="#0" :min="0" :max="100" />
              <DxNumberBox v-if="tipFlags?.AreValoare === true && tipFlags?.AreTva === true" label="Valoare TVA" label-mode="static"
                v-model:value="newDocument.ValoareTva" format="#,##0.00" :read-only="tipFlags?.AreLinii === true" />
              <DxNumberBox v-if="tipFlags?.AreValoare === true && tipFlags?.AreTva === true" label="Total" label-mode="static"
                v-model:value="newDocument.Total" format="#,##0.00" :read-only="tipFlags?.AreLinii === true" />
              <DxNumberBox v-if="tipFlags?.AreValoare === true && tipFlags?.CrossCateg !== 0" label="Sold" label-mode="static"
                :value="newDocument.Total" format="#,##0.00" :read-only="true" hint="Egal cu Total la creare" />
            </div>
          </div>

          <!-- Referințe -->
          <div v-if="data.id === 'referinte'" class="filter-group-inner">
            <div class="tab-empty-state" v-if="!hasReferinteTab">Acest tip de document nu are referințe suplimentare.</div>
            <div class="filter-input" v-if="tipFlags?.AreProiect === true">
              <DxLookup label="Proiect" label-mode="static" :data-source="dsProiecte" :value="newDocument.ProiectId"
                value-expr="Id" display-expr="Nume" placeholder="Selectează un proiect..." :showClearButton="true"
                :searchEnabled="true" @value-changed="onProiectSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="filter-input" v-if="tipFlags?.AreContract === true">
              <DxLookup label="Contract" label-mode="static" :data-source="dsContracte" :value="newDocument.ContractId"
                value-expr="Id" display-expr="NumeContract" placeholder="Selectează un contract..." :showClearButton="true"
                :searchEnabled="true" @value-changed="onContractSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="filter-input" v-if="tipFlags?.AreComanda === true">
              <DxLookup label="Comandă" label-mode="static" :data-source="dsComenzi" :value="newDocument.ComandaId"
                value-expr="Id" display-expr="Cod" placeholder="Selectează o comandă..." :showClearButton="true"
                :searchEnabled="true" @value-changed="onComandaSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="filter-input" v-if="tipFlags?.AreLotFabricatie === true">
              <DxLookup label="Lot Fabricație" label-mode="static" :data-source="dsLoturiFabricatie" :value="newDocument.LotFabricatieId"
                value-expr="Id" display-expr="Cod" placeholder="Selectează un lot..." :showClearButton="true"
                :searchEnabled="true" @value-changed="onLotFabricatieSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="filter-input" v-if="tipFlags?.AreStructIdEditabil === true">
              <DxLookup label="Structură Editabilă" label-mode="static" :data-source="dsStructuriIdEditabile"
                :value="newDocument.StructIdEditabil" value-expr="Id" display-expr="Nume"
                placeholder="Selectează o structură..." :showClearButton="true" :searchEnabled="true"
                @value-changed="onStructuraIdEditabilaSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="filter-input" v-if="tipFlags?.AreDocument === true">
              <DxLookup label="Document Asociat" label-mode="static" :data-source="dsDocumenteAsociate"
                :value="newDocument.DocGeneratAutomatId" value-expr="Id" display-expr="Numar"
                placeholder="Selectează documentul asociat..." :showClearButton="true" :searchEnabled="true"
                @value-changed="onDocumentAsociatSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
          </div>

          <!-- Aprobare & Stare — mapare 1:1 cu DOC_DocumentForm.cs: rowDocAprobaID (mereu vizibil),
               rowDocAnulat (vizibil implicit), rowStornat (AreIntrare||AreIesire||EsteCreanta||EsteObligatie),
               rowAutofacturat/rowEmisTert (EsteCreanta || EsteObligatie) -->
          <div v-if="data.id === 'aprobare'" class="filter-group-inner">
            <div class="filter-input">
              <DxLookup label="Aprobă" label-mode="static" :data-source="dsPerEmployees" :value="newDocument.AprobaId"
                value-expr="Id" :display-expr="perEmployeeDisplayExpr" placeholder="Selectează persoana care aprobă..."
                :showClearButton="true" :searchEnabled="true" @value-changed="onAprobaSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
            <div class="checkbox-grid">
              <DxCheckBox text="Anulat" v-model:value="newDocument.Anulat" />
              <DxCheckBox
                v-if="tipFlags?.AreIntrare === true || tipFlags?.AreIesire === true || tipFlags?.EsteCreanta === true || tipFlags?.EsteObligatie === true"
                text="Stornat/Retur" v-model:value="newDocument.StornatRetur" />
              <DxCheckBox v-if="tipFlags?.EsteCreanta === true || tipFlags?.EsteObligatie === true" text="Autofacturat"
                v-model:value="newDocument.Autofacturat" />
              <DxCheckBox v-if="tipFlags?.EsteCreanta === true || tipFlags?.EsteObligatie === true" text="Emis Terț"
                v-model:value="newDocument.EmisTert" />
            </div>
          </div>

          <!-- Note & Observații -->
          <div v-if="data.id === 'note'" class="filter-group-inner">
            <div class="tab-empty-state" v-if="!hasNoteTab">Acest tip de document nu are note suplimentare.</div>
            <div class="filter-input" v-if="tipFlags?.AreExplicatie === true">
              <DxTextArea label="Explicație" label-mode="static" :value="newDocument.Explicatie" height="52px"
                @value-changed="onExplicatieSelected" />
            </div>
            <div class="filter-input" v-if="tipFlags?.AreObservatii === true">
              <DxTextArea label="Observații" label-mode="static" :value="newDocument.Observatii" height="52px"
                @value-changed="onObservatiiSelected" />
            </div>
          </div>
        </div>
      </template>
    </DxTabPanel>
    <div class="form-footer footer-modern">
      <div class="footer-right">
        <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined" @click="onSaveAdd" />
        <DxButton text="Închide" type="danger" width="120" height="32" styling-mode="outlined" @click="onCloseAdd" />
      </div>
    </div>
  </DxPopupAdd>

</template>
<script lang='ts'>
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxEditing,
  DxExport,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxHeaderFilter,
  DxLoadPanel,
  DxPager,
  DxPaging,
  DxRemoteOperations,
  DxScrolling,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxTexts,
  DxToolbar,
  DxToolbarItem,
  DxItem
} from 'devextreme-vue/data-grid';
import DxTreeView from 'devextreme-vue/tree-view';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { DxNumberBox } from "devextreme-vue/number-box"
import DxDateBox from 'devextreme-vue/date-box';
import { DxLookup, DxDropDownOptions } from 'devextreme-vue/lookup';
import DxContextMenu from 'devextreme-vue/context-menu'
import DxTabPanel from 'devextreme-vue/tab-panel';
import DxPopupAdd from 'devextreme-vue/popup'
import { DxButton } from 'devextreme-vue/button';
import DxTextArea from 'devextreme-vue/text-area'
import { DxCheckBox } from 'devextreme-vue/check-box'
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import 'devextreme/data/array_store';
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";
import { DxPopup } from 'devextreme-vue';
import DxActionSheet from 'devextreme-vue/action-sheet';
import notify from 'devextreme/ui/notify'
import DOC_Documente from '@/services/Documente/DOC_Documente';
import DOC_Tipuri from '@/services/Documente/DOC_Tipuri';
import PRO_LoturiFabricatie from '@/services/Documente/PRO_LoturiFabricatie';
import http from '@/settings/apiSettings';
import { usePrintReport } from '@/composable/usePrintReport';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';

// Legacy setează Data/DataDoc doar cu data (DateTime.Today, fără oră) la document nou — un
// `new Date()` brut păstrează ora curentă, care apoi ajunge nemodificată în DB (bug confirmat
// 2026-07-29: DataDoc salvat cu ora exactă a creării, ex. 12:55:00, în loc de miezul nopții).
function startOfToday(): Date {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

// Trimiterea unui obiect Date brut către backend serializează implicit în UTC (JSON.stringify →
// Date.toISOString()) — miezul nopții la ora României (UTC+2/+3) devine ora 21-22 din ZIUA
// PRECEDENTĂ în UTC. Backendul (.NET) parsează acel instant UTC și taie ora cu `.Date`, fără
// conversie la ora locală — rezultă data salvată cu o zi în urmă. Trimițând "YYYY-MM-DD" simplu
// (din componentele LOCALE ale Date-ului, nu UTC) eliminăm complet ambiguitatea de fus orar.
function toDateOnlyString(d: Date | null | undefined): string | null {
  if (!d) return null;
  const dt = new Date(d);
  const yyyy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, '0');
  const dd = String(dt.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export default {

  name: 'DocumentView',
  setup() {
    const {
      isPrinting, previewReport,
      pdfBlobUrl, pdfPreviewSrc, pdfFileName, isPdfPreviewVisible,
      downloadPreviewReport, closePdfPreview,
    } = usePrintReport();
    return {
      isPrinting, previewReport,
      pdfBlobUrl, pdfPreviewSrc, pdfFileName, isPdfPreviewVisible,
      downloadPreviewReport, closePdfPreview,
    };
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxPager,
    DxColumnChooser,
    DxLookup,
    DxEditing,
    DxScrolling,
    DxLoadPanel,
    DxRemoteOperations,
    DxHeaderFilter,
    DxPaging,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxPopup,
    DxContextMenu,
    DxActionSheet,
    DxButton,
    DxTextBox,
    DxTextBoxButton,
    DxToolbar,
    DxToolbarItem,
    DxItem,
    DxPopupAdd,
    DxDropDownOptions,
    DxTextArea,
    DxDateBox,
    DxNumberBox,
    DxDropDownBox,
    DxTreeView,
    DxCheckBox,
    DxTabPanel
  },
  props: {
    initialFilters: {
      type: Object,
      default: null
    }
  },
  watch: {
    initialFilters: {
      handler(newVal) {
        this.loadData(newVal)
      },
      immediate: true
    }
  },
  data() {
    return {
      dsDocumente: null,
      dsTipDocumente: null,
      dsPartener: null,
      dsGestiune: null,
      dsValute: null,
      dsBanci: null,
      dsComenzi: null,
      dsProiecte: null,
      dsLoturiFabricatie: null,
      dsContracte: null,
      dsStructuriIdEditabile: null,
      dsAgent: null,
      dsPerEmployees: null,
      dsDocumenteAsociate: null,
      documenteDataGrid: 'documenteDataGrid',
      dsCategorieDocumente: null,
      dsCursValutar: null,
      document: Object,
      menuAppear: false,
      contextMenuItems: [
        { text: "Vezi Detalii", action: "details" },
        { text: "Option 2" },
        { text: "Option 3" }
      ],
      sharePopupVisible: false,
      sharedDocumentId: '',
      copyButton: {
        icon: 'copy',
        stylingMode: 'text',
        onClick: this.copyToClipboard
      },
      url: '',
      addButtonOptions: {
        icon: "add",
        type: "success",
        stylingMode: "contained",
        onClick: () => {
          this.onAddClick()
        },
      },
      isTipPopupVisible: false,
      isModalAddVisible: false,
      tipFlags: null as any,
      tipNumeSelectat: '',
      addSelectedTabIndex: 0,
      addTabItems: [
        { id: 'general', title: 'General', icon: 'dx-icon-card' },
        { id: 'financial', title: 'Financiar', icon: 'dx-icon-money' },
        { id: 'referinte', title: 'Referințe', icon: 'dx-icon-box' },
        { id: 'aprobare', title: 'Aprobare & Stare', icon: 'dx-icon-check' },
        { id: 'note', title: 'Note', icon: 'dx-icon-comment' }
      ],
      newDocument: {
        TipId: null,
        Numar: '#AUTO',
        Data: startOfToday(),
        PartenerId: null,
        GestiuneIntrareId: null,
        GestiuneIesireId: null,
        GestionarIntrareId: null,
        GestionarIesireId: null,
        ValutaId: null,
        LotFabricatieId: null,
        SpitalizareId: null,
        Curs: 1,
        Tva: 0,
        Explicatie: '',
        Observatii: '',
        ContBancaCasaId: null,
        ComandaId: null,
        StructuraId: null,
        ProiectId: null,
        DocGeneratAutomatId: null,
        ContractId: null,
        AgentId: null,
        Rezervat: null,
        DataDoc: startOfToday(),
        StructIdEditabil: null,
        DataScadenta: null,
        PretValutaId: null,
        PretCurs: null,
        PunctDeLucru: '',
        BatchId: null,
        Adaos: null,
        Valoare: null,
        ValoareTva: null,
        Total: null,
        AprobaId: null,
        Anulat: false,
        StornatRetur: false,
        Autofacturat: false,
        EmisTert: false,
      },
      treeViewDataSource: null,
      selectedTipId: null,
      dropDownBoxRef: null,
      externalFilters: null as any,
      showExtendedDetails: false
    }
  },
  computed: {
    hasFinanciarTab(): boolean {
      const f = this.tipFlags as any;
      return !!f && (f.AreIntrare === true || f.AreIesire === true || f.AreBanca === true ||
        f.AreValuta === true || f.AreAdaos === true || f.AreValoare === true);
    },
    hasReferinteTab(): boolean {
      const f = this.tipFlags as any;
      return !!f && (f.AreProiect === true || f.AreContract === true || f.AreComanda === true ||
        f.AreStructIdEditabil === true || f.AreDocument === true);
    },
    hasNoteTab(): boolean {
      const f = this.tipFlags as any;
      return !!f && (f.AreExplicatie === true || f.AreObservatii === true);
    },
    esteTipStorno(): boolean {
      const nume = (this.tipNumeSelectat || '').toLowerCase();
      return nume.includes('retur') || nume.includes('storn');
    }
  },
  mounted() {
    this.dsCategorieDocumente = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + 'DOC_Categorii',
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        },
      },
      pageSize: 500
    });
    this.loadAndTransformData()
    this.dsPartener = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `PAR_Parteneri`,
        key: 'ID',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    // Gestiune Intrare/Ieșire — verificat direct pe ERA_MidasoftTst: legacy permite alegerea
    // ORICĂRUI nod vizibil din ERP_StructuraCompanie (nu doar cele cu EsteGestiune=1) — un NIR
    // real creat din legacy avea GestiuneIntrareID pe un nod cu EsteGestiune=0 ("Financiar/Contabil").
    // Filtrul corect e doar EsteVizibil=true, la fel ca baza recursivă din ERP_StructuraCompanieRecursiv.sql.
    // Afișarea "Nume" clientului e de fapt Descr din tabelă (vezi gestiuneDisplayExpr mai jos).
    this.dsGestiune = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `ERP_StructuraCompanie`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
      filter: ['EsteVizibil', '=', true],
    });
    this.dsValute = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_ComercialOdata + `ERP_Valute`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsContracte = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_ComercialOdata + `COM_Contracte`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsBanci = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `ERP_BanciConturi`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsAgent = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + 'COM_Agenti',
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsComenzi = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `PRO_Comenzi`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsProiecte = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `DOC_Proiecte`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsStructuriIdEditabile = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + 'ERP_StructuraCompanie',
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      }
    });
    this.dsPerEmployees = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + 'PER_Employees',
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsDocumenteAsociate = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + 'DOC_Documente',
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsCursValutar = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_ComercialOdata + `ERP_CursValutar`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        fieldTypes: {
          ValutaID: "Guid"
        },
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsDocumente = this.createDocumenteDataSource()
  },
  // watch: {
  //   initialFilters: {
  //     handler(newVal) {
  //       this.loadData(newVal)
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    async copyToClipboard() {
      const textToCopy = this.url

      if (!textToCopy) {
        notify('Nu există ID de document de copiat.', 'warning', 5000);
        return;
      }

      try {
        await navigator.clipboard.writeText(textToCopy);
        notify('Adresa URL a fost copiată', 'success', 5000);
      } catch (err) {
        console.error('Eroare la copiere:', err);
        notify('Eroare la copiere. Copiere manuală necesară.', 'error', 5000);
      }
    },
    async loadAndTransformData() {
      try {
        const [categories, tipuriResp] = await Promise.all([
          this.dsCategorieDocumente.load(),
          DOC_Tipuri.getPermiseMele()
        ])
        // Tipurile de document afișate în arbore respectă drepturile utilizatorului (vezi
        // DOC_TipuriRepository.GetTipuriPermise) — nu se mai încarcă toate tipurile nefiltrate.
        const documentTypes = tipuriResp.data ?? []

        this.dsTipDocumente = new DataSource({
          store: new ArrayStore({ key: "Id", data: documentTypes })
        })

        const categoryMap = new Map()

        categories.forEach(cat => {
          categoryMap.set(cat.Id.toString().toLowerCase().trim(), {
            Id: cat.Id,
            Nume: cat.Nume,
            isCategory: true,
            items: []
          })
        })

        documentTypes.forEach(tip => {
          if (!tip.CategorieId) {
            return
          }

          let parentCategory = categoryMap.get(String(tip.CategorieId).toLowerCase().trim())
          if (parentCategory) {
            parentCategory.items.push({
              Id: tip.Id,
              Nume: tip.Nume,
              isCategory: false,
              items: []
            })
          } else {
            console.error(`Tipul de document ${tip.Nume} nu are o parinte categorie cu id ul: ${tip.CategorieId}`)
          }
        })

        // Categoriile rămase fără niciun tip vizibil (fie din drepturi, fie fără tipuri deloc)
        // nu se mai afișează în arbore — un nod expandabil gol n-ar avea niciun rost pentru user.
        const hierarchicalData = Array.from(categoryMap.values()).filter(cat => cat.items.length > 0)

        this.treeViewDataSource = new DataSource({
          store: new ArrayStore({
            key: "Id",
            data: hierarchicalData
          })
        })
      } catch (error) {
        console.error("Error loading or transforming data for TreeView:", error)
      }
    },
    onTreeViewItemSelectionChanged(e: any) {
      const selectedItem = e.itemData

      if (selectedItem && !selectedItem.isCategory) {
        this.newDocument.TipId = selectedItem.Id

        const dropDownBoxInstance = this.$refs.dropDownBoxRef;

        if (dropDownBoxInstance && dropDownBoxInstance.instance) {
          dropDownBoxInstance.instance.close();
        } else {
          console.error("Could not find DropDownBox instance to close.");
        }

        // Trece automat la pasul 2 imediat ce s-a ales un tip (nu o categorie) — fără click pe "Continuă"
        this.onTipContinue();
      }
    },
    onDropDownValueChanged(e: any) {
      this.selectedTipId = e.value
      this.newDocument.TipId = e.value
    },
    onStructuraIdEditabilaSelected(e: any) {
      this.newDocument.StructIdEditabil = e.value
    },
    onContractSelected(e: any) {
      this.newDocument.ContractId = e.value
    },
    onProiectSelected(e: any) {
      this.newDocument.ProiectId = e.value
    },
    onComandaSelected(e: any) {
      this.newDocument.ComandaId = e.value
      if (this.tipFlags?.AreLotFabricatie === true) {
        this.loadLoturiFabricatie(e.value)
      }
    },
    onLotFabricatieSelected(e: any) {
      this.newDocument.LotFabricatieId = e.value
    },
    // Ca in legacy (DOC_DocumentForm: RowEditComanda_EditValueChanged) — lista de loturi de fabricatie
    // se filtreaza pe comanda selectata; fara comanda, se afiseaza toate loturile nescoase din uz.
    async loadLoturiFabricatie(comandaId: string | null) {
      try {
        let items: any[] = []
        if (comandaId) {
          const resp = await PRO_LoturiFabricatie.getByComanda(comandaId)
          items = resp.data ?? []
        } else {
          const resp = await PRO_LoturiFabricatie.getAllActive()
          items = resp.data?.value ?? []
        }
        this.dsLoturiFabricatie = new DataSource({ store: new ArrayStore({ data: items, key: 'Id' }) })
      } catch (error) {
        console.error('Eroare la încărcarea loturilor de fabricație:', error)
        this.dsLoturiFabricatie = new DataSource({ store: new ArrayStore({ data: [], key: 'Id' }) })
      }
    },
    createDocumenteDataSource() {
      return new DataSource({
        store: {
          type: "odata",
          url: AppSetting.API_Url_DocumenteOdata + "DOC_CautareDocumente",
          key: "Id",
          keyType: "Guid",
          version: 4,
          fieldTypes: {
            TipId: 'Guid',
            CategorieId: 'Guid',
            GrupPartenerID: 'Guid',
            ZonaID: 'Guid',
            PartenerID: 'Guid',
            ProiectID: 'Guid',
            ComandaID: 'Guid',
            AgentID: 'Guid',
        },
          beforeSend: (e: any) => {
            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + (localStorage.getItem("ERA_Jwt") ?? "")
            };
          }
        }
      });
    },

    ensureDocumenteDataSource() {
      if (!this.dsDocumente) {
        this.dsDocumente = this.createDocumenteDataSource();
      }
    },
    loadData(params: any) {
      this.externalFilters = params;

      this.ensureDocumenteDataSource();

      const rawFilters = Array.isArray(this.externalFilters?.filters) && this.externalFilters.filters.length > 0 ? this.externalFilters.filters : null;

      this.dsDocumente.filter(rawFilters);

      return this.dsDocumente.reload();
    },
    refreshData() {
      return this.loadData(this.externalFilters);
    },
    onGridStateSaving(state: any) {
      const cleaned = { ...state };
      delete cleaned.filterValue;
      if (Array.isArray(cleaned.columns)) {
        cleaned.columns = cleaned.columns.map((c: any) => {
          const { filterValue, filterValues, ...rest } = c;
          return rest;
        });
      }
      localStorage.setItem('dsDocumente', JSON.stringify(cleaned));
    },
    onGridStateLoading() {
      const raw = localStorage.getItem('dsDocumente');
      return raw ? JSON.parse(raw) : null;
    },
    onBancaSelected(e: any) {
      this.newDocument.ContBancaCasaId = e.value
    },
    onNumarSelected(e: any) {
      this.newDocument.Numar = e.value
    },
    onExplicatieSelected(e: any) {
      this.newDocument.Explicatie = e.value
    },
    onObservatiiSelected(e: any) {
      this.newDocument.Observatii = e.value
    },
    onCursSelected(e: any) {
      this.newDocument.Curs = e.value
    },
    onValutaSelected(e: any) {
      this.newDocument.ValutaId = e.value
      if (e.value === null) {
        this.newDocument.Curs = 1
        return
      }

      const ds = this.dsCursValutar;
      ds.filter(['ValutaID', '=', e.value]);
      ds.sort([{ selector: 'Data', desc: true }]);
      ds.pageSize(1);

      ds.load().then((res) => {
        if (res && res.length > 0) {
          this.newDocument.Curs = res[0].Curs;
        } else {
          // Fallback la cursul implicit din tabela de valute dacă nu există istoric
          this.dsValute.store().byKey(e.value).then((valuta) => {
            if (valuta) {
              this.newDocument.Curs = valuta.Curs || 1;
            }
          });
        }
      });
    },
    onGestiuneIntrareSelected(e: any) {
      this.newDocument.GestiuneIntrareId = e.value
    },
    onGestiuneIesireSelected(e: any) {
      this.newDocument.GestiuneIesireId = e.value
    },
    // Legacy afișează "Nume - Descr" (vezi ERP_StructuraCompanieRecursiv.sql: "nume+' - '+descr as CodNume") —
    // câmpul brut "Nume" e de fapt codul scurt, denumirea reală e în "Descr".
    gestiuneDisplayExpr(item: any): string {
      if (!item) return '';
      return item.Descr ? `${item.Nume ?? ''} - ${item.Descr}`.replace(/^ - /, '') : (item.Nume ?? '');
    },
    onTipDocumentSelected(e: any) {
      this.newDocument.TipId = e.value
    },
    onPartenerSelected(e: any) {
      this.newDocument.PartenerId = e.value
      this.newDocument.ComandaId = null
      this.newDocument.ContractId = null
      this.newDocument.DocGeneratAutomatId = null
      if (this.dsComenzi) {
        this.dsComenzi.filter(e.value ? ['ClientId', '=', e.value] : null)
        this.dsComenzi.reload()
      }
      if (this.dsContracte) {
        this.dsContracte.filter(e.value ? ['ClientId', '=', e.value] : null)
        this.dsContracte.reload()
      }
      if (this.dsDocumenteAsociate) {
        this.dsDocumenteAsociate.filter(e.value ? ['PartenerId', '=', e.value] : null)
        this.dsDocumenteAsociate.reload()
      }
    },
    onDocumentAsociatSelected(e: any) {
      this.newDocument.DocGeneratAutomatId = e.value
    },
    onAddClick() {
      this.isTipPopupVisible = true
    },
    onCloseTipPopup() {
      this.isTipPopupVisible = false
      this.newDocument.TipId = null
    },
    async onTipContinue() {
      if (!this.newDocument.TipId) {
        notify('Selectați un tip de document pentru a continua.', 'error', 4000);
        return;
      }
      try {
        const resp = await http.clientDocumenteOdata.get(
          `DOC_Tipuri(${this.newDocument.TipId})?$select=Nume,ArePartener,AreBanca,AreValuta,AreScadenta,` +
          `AreProiect,AreContract,AreComanda,AreStructIdEditabil,AreExplicatie,AreObservatii,AreAgentId,` +
          `AreIntrare,AreIesire,AreAdaos,AreValoare,AreTva,AreLinii,EsteCreanta,EsteObligatie,CrossCateg,` +
          `Explicatie,Observatii,Tva,AreDocument,AreLotFabricatie`
        );
        this.tipFlags = resp.data;
        this.tipNumeSelectat = resp.data?.Nume ?? '';
        // Tipurile cu EsteObligatie=true (facturi furnizor) cer număr introdus manual — golim
        // placeholder-ul "#AUTO" ca userul să nu trebuiască să-l șteargă înainte de a tasta.
        if (resp.data?.EsteObligatie === true && this.newDocument.Numar === '#AUTO') {
          this.newDocument.Numar = '';
        }
        if (!this.newDocument.Explicatie && resp.data?.Explicatie) {
          this.newDocument.Explicatie = resp.data.Explicatie;
        }
        if (!this.newDocument.Observatii && resp.data?.Observatii) {
          this.newDocument.Observatii = resp.data.Observatii;
        }
        if (!this.newDocument.Tva && resp.data?.Tva) {
          this.newDocument.Tva = resp.data.Tva;
        }
        // La fel ca legacy (DOC_DocumentForm.cs: "document.StructIdEditabil = document.structuraID")
        // — pre-completează structura (departamentul) cu cea implicită a userului curent; rămâne
        // editabilă, userul poate alege alta înainte de salvare.
        if (resp.data?.AreStructIdEditabil === true && !this.newDocument.StructIdEditabil) {
          try {
            const structResp = await DOC_Documente.getStructuraCurenta();
            if (structResp.data?.StructuraId) {
              this.newDocument.StructIdEditabil = structResp.data.StructuraId;
            }
          } catch (err) {
            console.error('Eroare la încărcarea structurii implicite:', err);
          }
        }
        this.newDocument.StornatRetur = this.esteTipStorno;
        if (resp.data?.AreLotFabricatie === true) {
          await this.loadLoturiFabricatie(this.newDocument.ComandaId);
        }
      } catch (error) {
        console.error('Eroare la încărcarea flag-urilor tipului de document:', error);
        this.tipFlags = null;
        this.tipNumeSelectat = '';
      }
      this.isTipPopupVisible = false;
      this.isModalAddVisible = true;
      this.addSelectedTabIndex = 0;
    },
    onCloseAdd() {
      this.isModalAddVisible = false
      this.tipFlags = null
      this.tipNumeSelectat = ''
      this.newDocument.TipId = null
      this.newDocument.Numar = '#AUTO'
      this.newDocument.Data = startOfToday()
      this.newDocument.PartenerId = null
      this.newDocument.GestiuneIntrareId = null
      this.newDocument.GestiuneIesireId = null
      this.newDocument.ValutaId = null
      this.newDocument.Curs = 1
      this.newDocument.Tva = 0
      this.newDocument.Explicatie = ''
      this.newDocument.Observatii = ''
      this.newDocument.ComandaId = null
      this.newDocument.ProiectId = null
      this.newDocument.ContractId = null
      this.newDocument.AgentId = null
      this.newDocument.Rezervat = null
      this.newDocument.DataDoc = startOfToday()
      this.newDocument.StructIdEditabil = null
      this.newDocument.DataScadenta = null
      this.newDocument.PretValutaId = null
      this.newDocument.PretCurs = null
      this.newDocument.ContBancaCasaId = null
      this.newDocument.Adaos = null
      this.newDocument.Valoare = null
      this.newDocument.ValoareTva = null
      this.newDocument.Total = null
      this.newDocument.AprobaId = null
      this.newDocument.Anulat = false
      this.newDocument.StornatRetur = false
      this.newDocument.Autofacturat = false
      this.newDocument.EmisTert = false
      this.newDocument.DocGeneratAutomatId = null
      this.newDocument.LotFabricatieId = null
      this.showExtendedDetails = false
      if (this.dsComenzi) {
        this.dsComenzi.filter(null)
      }
      if (this.dsContracte) {
        this.dsContracte.filter(null)
      }
      if (this.dsDocumenteAsociate) {
        this.dsDocumenteAsociate.filter(null)
      }
      this.dsLoturiFabricatie = null
    },
    onAgentSelected(e: any) {
      this.newDocument.AgentId = e.value
    },
    onAddTabPanelOptionChanged(e: any) {
      if (e.name === 'selectedIndex') {
        this.addSelectedTabIndex = e.value
      }
    },
    bancaDisplayExpr(item: any) {
      return item ? `${item.Nume}${item.CodIban ? ' — ' + item.CodIban : ''}` : '';
    },
    perEmployeeDisplayExpr(item: any) {
      return item ? `${item.Surname ?? ''} ${item.Name ?? ''}`.trim() : '';
    },
    onAprobaSelected(e: any) {
      this.newDocument.AprobaId = e.value
    },

    async onSaveAdd() {
      if (this.newDocument.TipId === null) {
        notify('Nu puteti crea un document fara tip!', 'error', 5000);
        return;
      }
      if (this.tipFlags?.ArePartener === true && this.newDocument.PartenerId === null) {
        notify('Nu puteti crea un document fara partener!', 'error', 5000);
        return;
      }
      if (this.tipFlags?.EsteObligatie === true && !this.newDocument.Numar?.trim()) {
        notify('Introduceți numărul documentului!', 'error', 5000);
        return;
      }
      if (this.tipFlags?.AreStructIdEditabil === true && !this.newDocument.StructIdEditabil) {
        notify('Selectați structura (departamentul)!', 'error', 5000);
        return;
      }
      if (this.tipFlags?.AreIntrare === true && !this.newDocument.GestiuneIntrareId) {
        notify('Selectați gestiunea de intrare!', 'error', 5000);
        return;
      }
      if (this.tipFlags?.AreIesire === true && !this.newDocument.GestiuneIesireId) {
        notify('Selectați gestiunea de ieșire!', 'error', 5000);
        return;
      }
      try {
        const payload = {
          ...this.newDocument,
          Data: toDateOnlyString(this.newDocument.Data),
          DataDoc: toDateOnlyString(this.newDocument.DataDoc),
          DataScadenta: toDateOnlyString(this.newDocument.DataScadenta),
        };
        const response = await DOC_Documente.save(payload)
        if (response.status === 201 || response.status === 200) {
          notify('Documentul a fost salvat cu succes!', 'success', 5000);
          if (this.tipFlags?.AreScadenta === true && !this.newDocument.DataScadenta && response.data?.Scadenta) {
            const dataScadenta = new Date(response.data.Scadenta).toLocaleDateString('ro-RO');
            notify(`Nu ați completat data scadenței — a fost setată automat la ${dataScadenta}.`, 'warning', 6000);
          }
          this.onCloseAdd()
          this.refreshData()
          this.$emit("select-document", response.data)
        } else {
          notify('Ceva a mers prost!', 'danger', 5000);
        }
      } catch (error: any) {
        console.error("A aparut o eroare la salvarea documentului: ", error);
        const errorMsg = error?.response?.data?.error?.message || error?.message || 'Eroare necunoscută';
        notify('Eroare: ' + errorMsg, 'error', 5000);
      }
    },
    shareClicked(data) {
      this.sharePopupVisible = true
      this.sharedDocumentId = data.Id
      this.url = `${window.location.origin}` + `/documente?id=${this.sharedDocumentId}`
    },
    switchSharePopup() {
      this.sharePopupVisible = !this.sharePopupVisible
    },
    onRowDblClick(e: any) {
      if (e.data) {
        this.openDocument(e.data);
      }
    },
    openDocument(data: any) {
      this.$emit("select-document", data);
    },
    onExporting(e: any) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Documente');

      exportDataGridExcel({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer: any) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Documente.xlsx');
        });
      });
      e.cancel = true;
    },
    urlRaport(clasaRaport: string, documentID: string): string {
      const params = new URLSearchParams({ clasaRaport, documentID });
      return `${AppSetting.API_Url_Rapoarte}report/GetReportByClasaRaport?${params}`;
    },
    async onTipareseDocument(rowData: any) {
      const tipId = rowData.TipId;
      if (!tipId) {
        notify('Documentul nu are un tip asociat — nu se poate genera raportul.', 'warning', 3000);
        return;
      }
      try {
        const tipResp = await http.clientDocumenteOdata.get(
          `DOC_Tipuri(${tipId})?$select=ClasaRaport,ClasaRaport2,TitluRaport`
        );
        const tip = tipResp.data;
        const clasaRaport = tip?.ClasaRaport || tip?.ClasaRaport2;
        if (!clasaRaport) {
          notify('Tipul documentului nu are un raport configurat (ClasaRaport lipsă).', 'warning', 3000);
          return;
        }
        const token = localStorage.getItem('ERA_Jwt') ?? '';
        const fileName = `${tip?.TitluRaport || rowData.Tip || 'Document'}_${rowData.Numar ?? ''}`
          .replace(/[\\/:*?"<>|]/g, '-').trim() + '.pdf';
        const ok = await this.previewReport(this.urlRaport(clasaRaport, rowData.Id), token, fileName);
        if (!ok) notify('Raportul nu a putut fi generat.', 'error', 3000);
      } catch (error) {
        console.error('Eroare la generarea raportului:', error);
        notify('Eroare la generarea raportului.', 'error', 4000);
      }
    },
    // loadData(param) {
    //   this.dsDocumente = new DataSource({
    //     store: {
    //       type: 'odata',
    //       url: AppSetting.API_Url_DocumenteOdata + 'DOC_CautareDocumente',
    //       key: 'Id',
    //       keyType: "Guid",
    //       version: 4,

    //       beforeSend: (e: any) => {
    //         e.headers = {
    //           "Content-Type": "application/json",
    //           "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    //         };
    //       },
    //     },
    //   });
    //   this.dsDocumente.filter(param.filters);
    // },
  },
};
</script>
<style scoped>
.popup-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
}

.popup-header-icon {
  font-size: 18px;
  color: #fff;
}

.popup-header-title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}


:deep(.modern-form.dx-tabpanel .dx-tabpanel-tabs) {
  margin-bottom: 8px;
}

:deep(.modern-form.dx-tabpanel .dx-tab) {
  border-radius: 8px;
}

.footer-fixed {
  position: sticky;
  bottom: 0;
  padding: 10px 16px;
  display: flex;
  /* Forțează conținutul spre dreapta */
  justify-content: flex-end;
  gap: 12px;
  z-index: 10;
  /* Recomandat pentru sticky footer */
}

/* Eliminăm space-between care trimitea elementele în colțuri opuse */
.footer-modern {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 16px;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
}

.footer-right {
  display: flex;
  gap: 12px;
  /* Spațiu între cele două butoane */
}

.circle-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.circle-true {
  background-color: #4caf50;
  color: white;
}

.circle-false {
  border: 2px solid #aaa;
}

.show-more-container {
  display: flex;
  justify-content: center;
  margin: 2px 0;
}

.tip-popup-content {
  padding: 24px 6px 12px;
  flex: 1;
}

/* ── Layout identic cu DocumentDetails.vue (ecranul de editare) ── */
.filters-tabpanel {
  padding: 0 10px;
}

.tab-title-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 2px;
}

.tab-title-wrapper i {
  color: #64748b;
  font-size: 15px;
}

.tab-title-text {
  font-weight: 600;
  color: #1e293b;
  font-size: 13px;
}

.accordion-item-content {
  padding: 15px 10px 20px 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.filter-group-inner {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.filter-input {
  display: flex;
  flex-direction: column;
}

.form-field-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.tab-empty-state {
  padding: 24px 8px;
  color: #94a3b8;
  font-size: 13px;
  font-style: italic;
  text-align: center;
}

.show-more-native-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #ff2c21;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 18px;
  border-radius: 6px;
  white-space: nowrap;
  transition: background 0.15s;
}

.show-more-native-btn:hover {
  background: rgba(255, 44, 33, 0.07);
}

.show-more-native-btn .dx-icon {
  font-size: 14px;
}

/* Modern Form Styles */
.modern-form {
  padding: 6px 10px;
}

.url-textbox {
  margin-top: 23px;
}

.button-container {
  position: absolute;
  bottom: 15px;
  left: 20%;
  transform: translateX(-50%);
  display: flex;
  gap: 15px;
}

.dx-popup-content .dx-button {
  height: 45px;
  width: 150px;
}


.dx-texteditor.dx-invalid .dx-invalid-message {
  display: none;
}

.documente-wrapper {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f8f9fc;
}

.documente-grid {
  flex: 1;
  min-height: 0;
  margin: 12px;
  border-radius: 8px;
  overflow: hidden;
}

.documente-wrapper :deep(.dx-scrollable-scroll-content) {
  background-color: #ff6a4a !important;
  border-radius: 6px !important;
}

.documente-wrapper :deep(.dx-scrollbar-vertical),
.documente-wrapper :deep(.dx-scrollbar-horizontal) {
  background-color: #ffe4dc !important;
}

.documente-wrapper :deep(.dx-toolbar) {
  height: 32px !important;
}

.documente-wrapper :deep(.dx-toolbar-items-container) {
  height: 32px !important;
}

.documente-wrapper :deep(.dx-datagrid-filter-row .dx-texteditor) {
  height: 26px !important;
}

.documente-wrapper :deep(.dx-datagrid-filter-row .dx-texteditor-input) {
  height: 26px !important;
  min-height: unset !important;
}

.documente-wrapper :deep(.dx-row > td) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 11px !important;
  line-height: 1.1 !important;
}

.documente-wrapper :deep(.dx-datagrid-headers .dx-header-row td) {
  height: 24px !important;
}

.documente-wrapper :deep(.dx-datagrid-rowsview .dx-row) {
  height: 26px !important;
}

.documente-wrapper :deep(.deschide-btn) {
  height: 26px !important;
  width: 26px !important;
  min-width: unset !important;
  line-height: 26px !important;
}

.documente-wrapper :deep(.deschide-btn .dx-icon) {
  font-size: 16px !important;
  line-height: 26px !important;
}
</style>
<style>
.filter-toggle-btn {
  background-color: white !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  color: #475569 !important;
  height: 28px !important;
  font-size: 12px !important;
  margin-right: 8px;
  transition: all 0.2s ease !important;
}

.filter-toggle-btn .dx-icon {
  font-size: 14px !important;
}

.filter-toggle-btn:hover {
  color: #ff2c21 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}
</style>
